import { createApp, defineAsyncComponent } from "vue";

/**
 * Creates and mounts a new vue instance for memberships
 *
 * @param {Function} onCreated
 */
const initialise = (onCreated) => {
    const app = createApp();

    // app.component(
    //     "basket-widget",
    //     defineAsyncComponent(() => import("@app/products/Basket-Widget.vue"))
    // );

    // app.component(
    //     "basket-app",
    //     defineAsyncComponent(() => import("@app/products/Basket.vue"))
    // );

    // app.component(
    //     "basket-add-button",
    //     defineAsyncComponent(() => import("@app/products/basket-parts/BasketAddButton.vue"))
    // );

    app.component(
        "shortlist-widget",
        defineAsyncComponent(() => import("@app/shortlist/Shortlist-Widget.vue"))
    );

    app.component(
        "add-shortlist-button",
        defineAsyncComponent(() => import("@app/shortlist/Add-Shortlist-Button.vue"))
    );

    app.component(
        "job-shortlist",
        defineAsyncComponent(() => import("@app/jobs/Job-Shortlist.vue"))
    );

    app.component(
        "job-shortlist-topbar",
        defineAsyncComponent(() => import("@app/jobs/Job-Shortlist-Topbar.vue"))
    );

    app.component(
        "job-list",
        defineAsyncComponent(() => import("@app/jobs/Job-List.vue"))
    );

    app.component(
        "job-search-sidebar",
        defineAsyncComponent(() => import("@app/jobs/Job-Search.vue"))
    );

    app.component(
        "job-search-topbar",
        defineAsyncComponent(() => import("@app/jobs/Job-Search-Topbar.vue"))
    );

    app.mount("#page");
};

export default initialise;
